import { Fragment, useState } from "react";
import { useApi, useResource } from "@/lib/api";
import { PageHeader, Panel, StatusPill, Loading, ErrorNote, fmtTime, JsonView } from "@/components/kit";

export default function Audit() {
  const [outcome, setOutcome] = useState("");
  const [channel, setChannel] = useState("");
  const qs = new URLSearchParams({ limit: "200", ...(outcome && { outcome }), ...(channel && { channel }) }).toString();
  const { data, error, loading, reload } = useResource(`/audit?${qs}`);
  const call = useApi();
  const [verify, setVerify] = useState(null);
  const [open, setOpen] = useState(null);
  const sel = "rounded-sm border border-[var(--cc-line)] bg-white px-3 py-2 text-sm";
  return (
    <div>
      <PageHeader eyebrow="Evidence · Hash-chained" title="Audit History">
        <button data-testid="audit-verify-button" onClick={async () => setVerify(await call("/audit/verify"))} className="rounded-sm bg-[var(--cc-navy)] px-5 py-2 text-sm text-white hover:bg-[var(--cc-signal)] hover:text-[var(--cc-navy)]">Verify chain</button>
      </PageHeader>
      {verify && (
        <div data-testid="audit-verify-result" className={`mb-6 rounded-sm border p-4 text-sm ${verify.valid ? "border-[var(--cc-ok)] bg-[#0F8B6D]/5" : "border-[var(--cc-deny)] bg-[#C2412D]/5"}`}>
          <b>{verify.valid ? "Chain intact" : `Chain broken at #${verify.broken_at_seq}`}</b> · {verify.entries} entries {verify.head_hash && <span className="font-mono text-xs">· head {verify.head_hash.slice(0, 16)}…</span>}
        </div>
      )}
      <div className="mb-4 flex flex-wrap gap-2">
        <select data-testid="audit-filter-outcome" className={sel} value={outcome} onChange={(e) => setOutcome(e.target.value)}>
          <option value="">All outcomes</option>{["allowed", "denied", "not_configured", "error", "approved", "rejected"].map((o) => <option key={o}>{o}</option>)}
        </select>
        <select data-testid="audit-filter-channel" className={sel} value={channel} onChange={(e) => setChannel(e.target.value)}>
          <option value="">All channels</option>{["dashboard", "mcp", "oauth", "console", "qa"].map((o) => <option key={o}>{o}</option>)}
        </select>
        <button data-testid="audit-refresh" onClick={reload} className="rounded-sm border border-[var(--cc-line)] bg-white px-4 text-sm hover:border-[var(--cc-navy)]">Refresh</button>
      </div>
      <Panel testId="audit-table">
        {loading ? <Loading /> : error ? <ErrorNote error={error} /> : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[760px] text-left text-sm">
              <thead><tr className="border-b border-[var(--cc-line)] text-[11px] uppercase tracking-wider text-[var(--cc-muted)]">
                <th className="py-2">#</th><th>Time</th><th>Actor</th><th>Channel</th><th>Action</th><th>Outcome</th><th>Hash</th></tr></thead>
              <tbody>{data.map((e) => (
                <Fragment key={e.seq}>
                  <tr onClick={() => setOpen(open === e.seq ? null : e.seq)} className="cursor-pointer border-b border-[var(--cc-line)] hover:bg-[var(--cc-paper)]" data-testid={`audit-row-${e.seq}`}>
                    <td className="py-2 font-mono text-xs">{e.seq}</td><td className="font-mono text-[11px]">{fmtTime(e.timestamp)}</td>
                    <td className="max-w-[220px] truncate text-xs">{e.actor}</td><td className="text-xs">{e.channel}</td>
                    <td className="text-xs font-medium">{e.action}</td><td><StatusPill status={e.outcome} /></td>
                    <td className="font-mono text-[11px] text-[var(--cc-muted)]">{e.hash.slice(0, 10)}</td>
                  </tr>
                  {open === e.seq && <tr><td colSpan={7} className="py-3"><JsonView value={e} max="max-h-64" /></td></tr>}
                </Fragment>
              ))}</tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
